import debounce from 'debounce';
import { PlayerSdk } from '@api.video/player-sdk';
class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.player = null;
    this.id = this.getAttribute('data-id');
    this.source = this.getAttribute('data-source');
    this.playerTarget = this.querySelector('[data-target]');
    this.autoloop = this.getAttribute('data-autoloop') === 'true';
  }
  connectedCallback() {
    // bindings
    this.bndHandleResize = debounce(this.handleResize.bind(this), 250);
    // events
    this.onLoad();
    window.addEventListener('resize', this.bndHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.bndHandleResize);
    this.cleanup();
  }
  cleanup() {
    if (!this.player) return;
    if (this.source === 'youtube' && this.player.destroy) {
      this.player.destroy();
    } else if (this.source === 'apivideo' && this.player.destroy) {
      this.player.destroy();
    } else if (this.player instanceof HTMLElement) {
      this.playerTarget.removeChild(this.player);
    }
    this.player = null;
  }
  onLoad() {
    switch (this.source) {
      case 'apivideo':
        this.initApiVideo();
        break;
      case 'youtube':
        this.initYoutube();
        break;
      case 'dailymotion':
        this.initDailymotion();
        break;
      case 'vimeo':
        this.initVimeo();
        break;
      default:
        console.warn('Unknown video source:', this.source);
        break;
    }
  }
  handleResize() {
    // Implement resize handling if needed
  }
  createIframe(baseUrl, allowList = '') {
    if (!this.playerTarget || !this.id) return null;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('src', baseUrl);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', allowList);
    iframe.setAttribute('allowfullscreen', '');
    this.playerTarget.appendChild(iframe);
    return iframe;
  }
  initApiVideo() {
    if (!this.playerTarget || !this.id) return;
    const options = {
      id: this.id,
      ...(this.autoloop ? {
        autoplay: true,
        loop: true,
        muted: true,
        playsinline: true
        // Don't hide controls when autoloop is true
      } : {})
    };
    this.player = new PlayerSdk(this.playerTarget, options);
  }
  initYoutube() {
    let url = `https://www.youtube.com/embed/${this.id}?enablejsapi=1`;

    // Add autoloop params if enabled, ensure controls remain visible
    if (this.autoloop) {
      url += '&autoplay=1&loop=1&playlist=' + this.id + '&mute=1&playsinline=1';
      // YouTube shows controls by default, so we don't need to add controls=1
    }
    this.player = this.createIframe(url, 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
  }
  initDailymotion() {
    let url = `https://www.dailymotion.com/embed/video/${this.id}`;

    // Add autoloop params if enabled, ensure controls are shown
    if (this.autoloop) {
      url += '?autoplay=1&loop=1&mute=1&ui-start-screen-info=false';
      // Dailymotion shows controls by default
    }
    this.player = this.createIframe(url, 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
  }
  initVimeo() {
    let url = `https://player.vimeo.com/video/${this.id}`;

    // Add autoloop params if enabled
    if (this.autoloop) {
      // Remove background=1 parameter as it hides controls
      url += '?autoplay=1&loop=1&muted=1&playsinline=1';
    }
    this.player = this.createIframe(url, 'autoplay; fullscreen; picture-in-picture');
  }
}
customElements.define('video-player', VideoPlayer);